import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MenuItem, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { InventoryService } from '../../../services/inventory.service';
import _ from 'lodash';
import { AdministratorService } from '../../../services/administrator.service';
import { GSTInfo, Product, gridPageRequest } from '../../../model/common/common.model';
import { LoaderComponent } from '../../loader/loader.component';
import { UnitsOfMeasure } from '../../../model/administration.model';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { GstListLookupComponent } from '../gst-list-lookup/gst-list-lookup.component';
import { InventoryStatusLookupComponent } from '../inventory-status-lookup/inventory-status-lookup.component';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { LedgerLookupComponent } from '../ledger-lookup/ledger-lookup.component';
import { Observable, catchError, of, switchMap } from 'rxjs';
@Component({
  selector: 'app-viewproductdata-lookup',
  standalone: true,
  imports: [SharedModule, CommonModule, LoaderComponent, TieredMenuModule],
  providers: [MessageService],
  templateUrl: './viewproductdata-lookup.component.html',
  styleUrl: './viewproductdata-lookup.component.scss'
})
export class viewproductdataLookupComponent implements OnInit {
  @ViewChild('fileInput') fileInput!: ElementRef;
  productId: any;
  hide: boolean = false;
  constructor(private config: DynamicDialogConfig, private messageService: MessageService, private router: Router, private sanitizer: DomSanitizer, private inventoryService: InventoryService,
    private route: ActivatedRoute, private administratorService: AdministratorService, public dialogService: DialogService, public ref: DynamicDialogRef) { }

  activeIndex: number = 0;
  loader: boolean = false;
  RoleId: number = 0;
  iseditProduct: boolean = false;
  editProductData: any;
  submitted: boolean = false;
  value: string = '';
  Attributes: any[] = [];
  saveImage: Blob | undefined;
  isManual: boolean = false;
  deletedImage: string | undefined;
  SalesOrderLineItemId: number | undefined;


  selectedFile: File | null = null;
  previewImage: string | null = null;

  items: MenuItem[] | undefined;

  product: Product[] = [];

  createProductForm = new FormGroup({
    ProductId: new FormControl(0),
    ProductName: new FormControl('', Validators.required),
    ProductCode: new FormControl('', [Validators.required, Validators.pattern(/^[a-zA-Z0-9]*$/)]),
    ProductDescription: new FormControl(''),
    ProductImage: new FormControl(),
    CostCalculation: new FormControl(''),
    CanBeSold: new FormControl(false),
    CanBePurchased: new FormControl(false),
    CanBeRented: new FormControl(false),
    isactive: new FormControl(true, Validators.requiredTrue),
    IsTaxable: new FormControl(true),
    isLotTracking: new FormControl(false),
    IsInventory: new FormControl(true),
    isLocationTracking: new FormControl(false),
    isSerialTracking: new FormControl(false),
    ProductType: new FormControl('', Validators.required),
    producttypedropdown: new FormControl(''),
    UOM: new FormControl(''),
    UnitsofMeasureId: new FormControl(null),
    UnitsOfMeasure: new FormControl('', Validators.required),
    PurchasingUom: new FormControl('EA'),
    SellingUom: new FormControl('EA'),
    SalesPrice: new FormControl('', Validators.required),
    StandardCost: new FormControl('', Validators.required),
    Weight: new FormControl(0),
    CategoryId: new FormControl(0),
    CategoryValue: new FormControl('', Validators.required),
    GSTId: new FormControl(),
    HSNCode: new FormControl(),
    Barcode: new FormControl(''),
    ProductSize: new FormControl(''),
    VendorName: new FormControl(''),
    CreatedBy: new FormControl(''),
    UpdatedBy: new FormControl(),
     ColorId: new FormControl<any>(null),
    ColorName: new FormControl<any>(null),
    ProductGroupName: new FormControl(null),
    GroupId: new FormControl<any>(null),
    GroupValue: new FormControl(''),   
    SubCategoryName: new FormControl(null),
    SubCategoryId:new FormControl<any>(null),
    VendorProductCode: new FormControl(null),
    manualEntry: new FormControl(true),
    IsServiceType: new FormControl(''),
    ProductSpecification: new FormControl(),
    StandardType: new FormControl(),
    gstRate: new FormControl(),
    VendorId: new FormControl(),


  });

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 100,
    id: 0
  }

  UOMDropdown: UnitsOfMeasure[] = [];
  filteruom: UnitsOfMeasure[] = [];
  ProductTypeDropdown: any[] = [];
  CategoryDropdown: any[] = [];
  filterproducttype: any[] = [];
  GSTList: GSTInfo[] = [];

  ngOnInit(): void {
   this.productId = this.config.data?.productId;
    this.createProductForm.controls.CreatedBy.setValue(localStorage.getItem('username'));
    if (this.config.data?.productData) {
      this.editProductData = this.config.data.productData;
      this.EditProduct(this.editProductData);
    } else if (this.productId) {
      this.getProduct(this.pageRequest);
    }


    this.items = [
      {
        label: 'Inventory Status',
        command: () => this.showInventoryStatus(),
      },
      {
        label: 'Ledger',
        command: () => this.showLedger(),
      },
    ];
    // this.getSystemConfigData();
  }



  setBase64Image(imageBase64: string) {
    this.previewImage = `data:image/jpeg;base64,${imageBase64}`;
  }


EditProduct(data: any) {
  try {
    const productData = JSON.parse(data);
    if (!productData?.productId) return;

    this.loader = true;
    this.iseditProduct = true;

    this.inventoryService.getProductById(productData.productId).subscribe({
      next: (res: any) => {
        this.loader = false;

        this.createProductForm.patchValue({
          ProductId: res.productId,
          ProductCode: res.productCode,
          ProductName: res.productName,
          ProductImage: res.productImage,
          ProductDescription: res.productDescription,

          CostCalculation: res.costCalculation,
          CanBePurchased: res.canBePurchased,
          CanBeRented: res.canBeRented,
          CanBeSold: res.canBeSold,
          isactive: res.isActive,
          IsTaxable: res.isTaxable,
          IsInventory: res.isInventory,

          isLocationTracking: res.isLocationTracking,
          isLotTracking: res.isLotTracking,
          isSerialTracking: res.isSerialTracking,

          ProductType: res.productType,
          UnitsOfMeasure: res.unitsOfMeasure,
          UnitsofMeasureId: res.unitsofMeasureId,
          PurchasingUom: res.purchasingUom,
          SellingUom: res.sellingUom,

          SalesPrice: res.salesPrice,
          StandardCost: res.standardCost,
          Weight: res.weight,

          CategoryId: res.categoryId,
          CategoryValue: res.category?.categoryName || '',

          SubCategoryId: res.subCategoryId,
          SubCategoryName: res.subCategory?.subCategoryName || '',

          ProductGroupName: res.productGroups?.productGroupName || '',
          GroupId: res.groupId,
          GroupValue: res.productGroups?.productGroupName || '',

          HSNCode: res.hsnCode,
          GSTId: res.gstId,
          gstRate: res.gstRate,

          Barcode: res.barcode,
          ProductSize: res.productSize,

          VendorId: res.vendorId,
          VendorName: res.vendor?.vendorName || '',
          VendorProductCode: res.vendorProductCode,

          ColorId: res.color?.colorId || '',
          ColorName: res.color?.colorName || '',

          ProductSpecification: res.productSpecification,
          IsServiceType: res.isServiceType === true ? 'Y' : 'N',
          StandardType: res.standardType,
          producttypedropdown: res.productTypeName, 
          UOM: res.unitsOfMeasure

,
          UpdatedBy: localStorage.getItem('username')
        });

        if (res.productImage) {
          this.setBase64Image(res.productImage);
        }
      },
      error: (err) => {
        console.error(err);
        this.loader = false;
      }
    });

  } catch (error) {
    console.error('Invalid product data', error);
  }
}


  getProduct(query: gridPageRequest): void {
    this.inventoryService.getProductById(this.productId).subscribe({
      next: (data: any) => {
        this.loader = false;
        this.iseditProduct = true;
        this.createProductForm.patchValue({
          ProductId: data.productId,
          ProductCode: data.productCode,
          ProductName: data.productName,
          ProductImage: data.productImage,
          ProductDescription: data.productDescription,
          CostCalculation: data.costCalculation,
          CanBePurchased: data.canBePurchased,
          CanBeRented: data.canBeRented,
          CanBeSold: data.canBeSold,
          isactive: data.isActive,
          IsTaxable: data.isTaxable,
          IsInventory: data.isInventory,
          isLocationTracking: data.isLocationTracking,
          isLotTracking: data.isLotTracking,
          isSerialTracking: data.isSerialTracking,
          ProductType: data.productType,
          UOM: data.unitsofMeasures,
          UnitsOfMeasure: data.unitsOfMeasure,
          UnitsofMeasureId: data.unitsofMeasureId,
          PurchasingUom: data.purchasingUom,
          SellingUom: data.sellingUom,
          SalesPrice: data.salesPrice,
          StandardCost: data.standardCost,
          Weight: data.weight,
          CategoryValue: data.category.categoryName,
          CategoryId: data.categoryId,
          HSNCode: data.hsnCode,
          GSTId: data.gstId,
          producttypedropdown: data.productType,
          Barcode: data.barcode,
          ColorId: data.colorId,
          ColorName: data.ColorName,
          ProductGroupName: data.ProductGroupName,
          GroupId: data.GroupId,
          SubCategoryName: data.SubCategoryName,
          SubCategoryId:data.SubCategoryId,
          VendorProductCode:data.VendorProductCode,
          IsServiceType:data.isServiceType
        });
        if (data.productImage) {
          this.setBase64Image(data.productImage);
        }
      }
    });
  }


  showInventoryStatus() {
    this.ref = this.dialogService.open(InventoryStatusLookupComponent, {
      header: `Inventory Status for Product Code: ${this.createProductForm.controls.ProductCode.value}`,
      width: '80%',
      data: { ProductCode: this.createProductForm.controls.ProductCode.value }

    });

  }

  showLedger() {
    this.ref = this.dialogService.open(LedgerLookupComponent, {
      header: `Ledger Card for Product: ${this.createProductForm.controls.ProductCode.value}`,
      width: '80%',
      data: { ProductCode: this.createProductForm.controls.ProductCode.value, ProductId: this.createProductForm.controls.ProductId.value }

    });

  }
// getSystemConfigData(): void {
//   this.loader = true;
//   const appKey = 'hide.columns_Products';

//   this.inventoryService.getSystemConfigByAppKey(appKey).subscribe({
//     next: (response: any) => {
//       this.loader = false;
//       if (response.appKeycode === appKey) {
//         this.hide = response.data === 'N';
//       }
//     },
//     error: error => {
//       console.error('Error fetching System Config Data:', error);
//       this.loader = false;
//     }
//   });
// }


}


